import React from "react";
import "./index.less";

const Screen = (props) => {
  // const { history } = props;
  return <div>test</div>;
};

export default Screen;
